<form [formGroup]="filterForm" class="top-actions">
    <mat-form-field *ngIf="isInternalUser" color="primary" appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'PROJECTS.project-list.title' | translate }}</mat-label>
        <mat-select formControlName="projectSelect">
            <mat-option *ngFor="let selection of projectSelections()" [value]="selection">
                {{ getTranslationForSelection(selection) }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>{{ 'shared.search' | translate }}</mat-label>
        <input matInput formControlName="search" autocomplete="not" />
        <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>


</form>

<div class="app-table-container">
    <table mat-table matSort [dataSource]="dataSource" class="app-table app-table-hoverable">
        <!-- Favorite Column -->
        <ng-container matColumnDef="favorite">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <button mat-icon-button [color]="element.isFavorite ? 'primary' : 'accent'"
                    (click)="toggleFavorite(element)" [matTooltip]="
              (element.isFavorite
                ? 'customer-spaces.customer-space-list.favorites.active'
                : 'customer-spaces.customer-space-list.favorites.inactive'
              ) | translate
            " matTooltipPosition="after" [attr.aria-label]="
              (element.isFavorite
                ? 'customer-spaces.customer-space-list.favorites.active'
                : 'customer-spaces.customer-space-list.favorites.inactive'
              ) | translate
            ">
                    <mat-icon [svgIcon]="element.isFavorite ? 'favorite_filled' : 'favorite_outlined'" />
                </button>
            </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>{{ 'customer-spaces.name' | translate }}
            </th>
            <td mat-cell *matCellDef="let element">
                <div class="project-name">
                    <div class="project-text">
                        <b>{{ element.name }}</b>
                    </div>
                    <a (click)="navigateToCockpit(element, $event)">
                        {{ element.customerSpaceName }}
                    </a>
                </div>
            </td>
        </ng-container>

        <!-- Number Column -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let project">
                <span *ngIf="project.abacusProjectNumbers.length > 0"
                    matTooltip="{{ 'PROJECTS.project-list.erp-project' | translate }} {{ project.abacusProjectNumbers.join(', ') }}"
                    class="erp-id">
                    {{ 'PROJECTS.project-list.erp-project' | translate }}
                    <a *ngIf="isInternalUser()"
                        (click)="onProjectNumbersClick($event, project.abacusProjectReportingLinkBase, project.abacusProjectNumbers)">
                        {{ project.abacusProjectNumbers.join(', ') }}
                    </a>
                    <span *ngIf="!isInternalUser()">
                        {{ project.abacusProjectNumbers.join(', ') }}
                    </span>
                </span>
                <div class="project-numbers-list" *ngIf="project.abacusProjectNumbers!.length > 1">
                    <div *ngFor="let abacusProjectNumber of project.abacusProjectNumbers; let j = index"
                        class="abacus-numbers">
                        <a
                            (click)="openAbacusLink($event, project.abacusProjectReportingLinkBase, project.abacusProjectNumbers[j])">
                            {{ abacusProjectNumber }}
                        </a>
                    </div>
                </div>
            </td>
        </ng-container>

        <!-- Sharepoint Column -->
        <ng-container matColumnDef="sharepoint">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <a *ngIf="!element.isAssignedToMe" mat-icon-button class="sharepoint-link"
                    [href]="element.sharePointLink" target="_blank" matTooltip="{{ 'shared.open' | translate }}">
                </a>
            </td>
        </ng-container>

        <!-- Edit Column -->
        <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let element">
                <a *appShowAuthorize="'CUSTOMER_SPACE_WRITE'; options: { values: { customerSpaceId: element.id } }"
                    mat-icon-button [routerLink]="['/', 'customer-spaces', element.id, 'admin']"
                    [matTooltip]="'shared.edit' | translate" matTooltipPosition="after">
                    <mat-icon svgIcon="edit_icon" />
                </a>
            </td>
        </ng-container>

        <!-- Tasks Column -->
        <ng-container matColumnDef="tasks">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear><mat-icon svgIcon="task"
                    class="header-icon" /></th>
            <td mat-cell *matCellDef="let element">
                <a mat-icon-button [routerLink]="['/', 'projects', element.id, 'tasks']"
                    [matTooltip]="'shared.tasks' | translate" matTooltipPosition="after">
                    <mat-icon [matBadge]="element.openTaskCount" matBadgeSize="medium"
                        [matBadgeHidden]="element.openTaskCount <= 0" svgIcon="task" aria-hidden="false" />
                </a>
            </td>
        </ng-container>


        <!-- Notifications Column -->
        <ng-container matColumnDef="notifications">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
                <mat-icon svgIcon="notifications_icon" class="header-icon" />
            </th>
            <td mat-cell *matCellDef="let project">
                <button mat-icon-button matTooltip="{{ 'shared.notifications' | translate }}">
                    <mat-icon
                        [matBadge]="project.notificationCount"
                        matBadgeSize="medium"
                        [matBadgeHidden]="project.notificationCount <= 0"
                        svgIcon="notifications_icon"
                        aria-hidden="false"
                      />
                </button>
            </td>
        </ng-container>

        <tr mat-header-row
            *matHeaderRowDef="['favorite', 'name', 'description',  'sharepoint', 'edit', 'tasks', 'notifications']">
        </tr>
        <tr mat-row
            *matRowDef="let row; columns: ['favorite', 'name', 'description', 'sharepoint', 'edit', 'tasks', 'notifications']">
        </tr>
    </table>
</div>

<app-empty-list *ngIf="dataSource.filteredData.length === 0"
    [text]="'customer-spaces.customer-space-list.empty-list' | translate" />

<mat-paginator [pageSizeOptions]="[50, 100, 500, 1000, 5000]" />

<div class="bottom-actions">
    <a *appShowAuthorize="'CUSTOMER_SPACE_CREATE'" mat-stroked-button color="primary"
        [routerLink]="['/customer-spaces', 'create']">
        <mat-icon svgIcon="add_icon" />
        {{ 'customer-spaces.customer-space-list.actions.create-customer-space' | translate }}
    </a>
</div>